import { PaymentTermAdmin } from "src/api-service";
import { AppError } from "../../../../app-store-error.types";

export interface PaymentTermsState {
    paymentTerms: PaymentTermAdmin[] | undefined;
    loaded: boolean;
    loading: boolean;
    error: AppError | null;
}

export const initialPaymentTermsState: PaymentTermsState = {
    paymentTerms: undefined,
    loaded: false,
    loading: false,
    error: null,
};
